import React from 'react';
import { Button } from 'react-bootstrap';
import FormSection from './FormSection';
import FormField from './FormField';

const BusinessTypes = [
	'Plumber',
	'Roofer',
	'Med Spa Owner',
	'Electrician',
	'HVAC Technician',
	'Landscaper',
	'Painter',
	'Pest Control',
	'Locksmith',
];

const PersonaFieldDefs = [
	{ key: 'prospect_name', label: 'Prospect Name', type: 'text' },
	{ key: 'business_name', label: 'Business Name', type: 'text' },
	{ key: 'business_type', label: 'Business Type', type: 'datalist', options: BusinessTypes },
	{ key: 'prospect_age', label: 'Age', type: 'number' },
	{ key: 'personality_trait', label: 'Personality Trait', type: 'textarea' },
	{ key: 'scenario', label: 'Scenario', type: 'textarea' },
	{ key: 'beliefs', label: 'Beliefs', type: 'textarea' },
	{ key: 'initial_greeting', label: 'Initial Greeting', type: 'textarea' },
	{ key: 'trade_question', label: 'Trade Question', type: 'text' },
];

function PersonaFields({ config, on_change, on_randomize }) {
	return (
		<FormSection
			title="Persona Fields"
			header_action={
				<Button size="sm" variant="outline-secondary" onClick={on_randomize}>
					Randomize
				</Button>
			}>
			{PersonaFieldDefs.map(function(field) {
				return (
					<FormField
						key={field.key}
						field={field}
						value={config[field.key]}
						on_change={on_change}
					/>
				);
			})}
		</FormSection>
	);
}

export default PersonaFields;
